import React, { useState } from 'react'
import { FaTrash, FaCheck, FaTimes } from 'react-icons/fa'
import SwitchInput from '../../../shared/SwitchInput'

import CustomTable from '../../../shared/CustomTable'
import CustomPagination from '../../../shared/CustomPagination'
import { DeleteIcon, EditIcon } from '../../../utils/TableActionIcons'
import CheckPermission from '../../../hooks/CheckPermission'
import toast from 'react-hot-toast'
import { spColumns } from '../../../constants/SpecialityConstants'
import { useTranslation } from 'react-i18next'
import {
  useUpdateSpecialityMutation,
  useDeleteSpecialityMutation,
} from '../../../shared/../redux/api/modules/managementApi'
const ConfirmationModal = React.lazy(() =>
  import('../../../shared/ConfirmationModal')
)
function SpecialityTable ({
  specialityData,
  loading,
  payloadData,
  setPayloadData,
  setOpenModal,
  setSelectedData,
  selectedData,
}) {
  const { t } = useTranslation()
  const { hasPermission } = CheckPermission()
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)
  const [updateSpeciality, { isLoading: isUpdating }] = useUpdateSpecialityMutation()
  const [deleteSpeciality, { isLoading: isDeleting }] = useDeleteSpecialityMutation()
  const buttonLoading = isDeleting
  
  const handleToggleActive = async (rowData, value) => {
    if (!hasPermission('speciality', 'update')) return
    const payload = {
      id: rowData?.id,
      name_en: rowData?.name_en,
      name_ar: rowData?.name_ar,
      department_id: rowData?.department?.id || rowData?.department_id,
      rcm_ref: rowData?.rcm_ref,
      description: rowData?.description,
      intervel: rowData?.intervel,
      number_of_followup: rowData?.number_of_followup,
      is_active: value
    }
    try {
      const res = await updateSpeciality(payload).unwrap()
      if (res?.message) toast.success(res.message)
    } catch (error) {
      toast.error(error?.data?.message || error?.message || t('Failed to update speciality'))
    }
  }
  
  const actionsCoumn = {
    body: actionsTemplate,
    header: t('Actions')
  }
  const columnsData = [actionsCoumn, ...spColumns(t)]?.map(col => {
    if (col.field === 'in_patient') {
      return {
        ...col,
        body: rowData => (
          <div>
            {rowData.in_patient ? (
              <FaCheck className='text-green-600 text-lg' />
            ) : (
              <FaTimes className='text-red-600 text-lg' />
            )}
          </div>
        )
      }
    }
    if (col.field === 'is_active') {
      return {
        ...col,
        body: rowData => (
          <SwitchInput
            disabled={!rowData?.department?.id || !hasPermission('speciality', 'update')}
            value={rowData?.is_active}
            handleChange={(e) => handleToggleActive(rowData, e?.value)}
          />
        )
      }
    }
    return col
  })

  function actionsTemplate (rowData) {
    return (
      <div className='flex items-center gap-1'>
        {hasPermission('speciality', 'update') && (
          <EditIcon
            onClick={() => {
              setOpenModal(true)
              setSelectedData(rowData)
            }}
          />
        )}
        {/* {hasPermission('department', 'delete') && (
          <DeleteIcon
            onClick={() => {
              setSelectedData(rowData)
              setOpenConfirmationModal(true)
            }}
          />
        )} */}
      </div>
    )
  }

  const onPageChange = async (newPage, newRowsPerPage) => {
    setPayloadData(prev => ({
      ...prev,
      page: newPage,
      per_page: newRowsPerPage
    }))
  }

  return (
    <div className='w-full h-full'>
      <div>
        <CustomTable
          data={specialityData || []}
          columns={columnsData}
          // emptyMessage='No Drivers Data Found'
          isLoading={loading}
        />
        {/* {specialityData?.data?.length > 0 && (
          <CustomPagination
            currentPage={specialityData?.page}
            rowsPerPage={specialityData?.per_page}
            totalRecords={specialityData?.total_records}
            totalPages={specialityData?.total_pages}
            onPageChange={onPageChange}
          />
        )} */}
      </div>
      <ConfirmationModal
        visible={openConfirmationModal}
        setVisible={setOpenConfirmationModal}
        header={'Confirm Delete'}
        isLoading={buttonLoading}
        acceptLabel={'Delete'}
        rejectLabel={'Cancel'}
        Icon={FaTrash}
        onAccept={async () => {
          if (!hasPermission('speciality', 'delete')) return
          try {
            const res = await deleteSpeciality({ id: selectedData?.id }).unwrap()
            if (res?.message) toast.success(res.message)
            setOpenModal(false)
            setSelectedData(null)
            setOpenConfirmationModal(false)
          } catch (error) {
            toast.error(error?.data?.message || error?.message || t('Failed to delete speciality'))
          }
        }}
        onReject={() => setSelectedData(null)}
      />
    </div>
  )
}

export default SpecialityTable
